import type { TConditionalCustomField } from '@atlas/tool/box/conditional-fields/evaluate';
import type { TValue } from '@atlas/tool/box/conditional-fields/comparator';

export const tagsKey = 'tags';
const tagsLabel = 'Tags';
export const channelKey = 'channel';
export const ticketFieldKeys = [tagsKey, channelKey];

const hintTemplate = 'Fill out {FIELDS} first';

export default function determineFieldDisabledStatus(options: {
    customField?: TConditionalCustomField;
    customFieldsValues: { key: string; name: string; value: TValue }[];
    tags?: string[];
}) {
    const { customField, customFieldsValues, tags } = options;
    const rules = customField?.rules || [];
    let disableField = true;
    let unfilledFieldsList: string[] = [];
    let unfilledFieldsSet: Set<string> = new Set();
    const conditionsWithUnfilledFields = [];

    for (const rule of rules) {
        const conditions = rule.conditions.all;

        for (const condition of conditions) {
            const { entity, field } = condition;
            const [keyGroup, dependentKey] = field.split('.');
            if (entity !== customField?.category) continue;

            if (keyGroup === tagsKey && Array.isArray(tags) && !tags.length) {
                unfilledFieldsList.push(tagsLabel);
            }

            const matchedCustomField = customFieldsValues.find((f) => f.key === dependentKey);
            if (!matchedCustomField) continue;

            const isEmptyValue =
                !matchedCustomField.value ||
                (Array.isArray(matchedCustomField.value) && !matchedCustomField.value.length);
            if (isEmptyValue) {
                unfilledFieldsList.push(matchedCustomField.name);
            }
        }

        disableField = unfilledFieldsList.length > 0;

        conditionsWithUnfilledFields.push({
            disableField,
            unfilledFieldsList,
        });

        let unfilledFieldsArray = Array.from(unfilledFieldsSet);
        unfilledFieldsArray = unfilledFieldsArray.concat(unfilledFieldsList);
        unfilledFieldsSet = new Set(unfilledFieldsArray);
        unfilledFieldsList = [];
    }

    const unfilledFieldsFlatList = Array.from(unfilledFieldsSet);
    const hint =
        unfilledFieldsFlatList.length > 0 ? hintTemplate.replace('{FIELDS}', unfilledFieldsFlatList.join(', ')) : '';

    return {
        hint,
        unfilledFieldsFlatList,
        disabled: conditionsWithUnfilledFields.length > 0 && conditionsWithUnfilledFields.every((r) => r.disableField),
    };
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('determineFieldDisabledStatus', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
